import styled from "styled-components";
import { GenericSolidButton } from "../../components/UI/buttons/Button.styled";
import Colors from "../../constants/Colors";

export const SaveButton = styled(GenericSolidButton)`
    background-color: white;
    border: 1px solid #0A5190;
    color: ${Colors.SPM600}

`